import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.splice.js";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import BookingModule from "@/store/modules/booking";
import ModalModule from "@/store/modules/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { computed, defineComponent, ref } from "vue";
import check from "@/assets/images/svg/green-check.svg";
export default defineComponent({
  name: ModalComponents.DiscountSelectTickets,
  setup: function setup() {
    var iconStyle = "width: 20px; height: 40px;";
    var iconContent = check;
    var iconAlt = "check";
    var ticketsQuery = ref("");
    var pageSize = ref(5);
    var currentPage = ref(1);

    var changeCurrentPage = function changeCurrentPage(val) {
      currentPage.value = val;
    };

    var dialogVisible = dialogVisibleForStatus(ModalStatus.DiscountSelectTickets);
    var totalPssListLength = computed(function () {
      var _BookingModule$select;

      return (_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.pssList.length;
    }); // A list of prices of the booking (no duplicates)

    var pricesList = computed(function () {
      var _BookingModule$select2;

      var nonDuplicatedPricesIds = _toConsumableArray(new Set((_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.pssList.map(function (pss) {
        return pss.priceId;
      })));

      var prices = [];
      nonDuplicatedPricesIds.forEach(function (priceId) {
        var _BookingModule$select3;

        var pp = (_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.pssList.find(function (pss) {
          return pss.priceId === priceId;
        });
        if (pp) prices.push({
          priceId: pp.priceId,
          categoryName: pp.categoryName,
          priceName: pp.priceName,
          priceValue: pp.priceValue,
          priceType: pp.pssType
        });
      });
      return prices;
    });
    var selectedPrices = ref([]);
    fillDiscountPrices(selectedPrices.value);

    function fillDiscountPrices(pricesIds) {
      var _BookingModule$select4;

      var discountPrices = (_BookingModule$select4 = BookingModule.selectedBookingDiscountTrack) === null || _BookingModule$select4 === void 0 ? void 0 : _BookingModule$select4.pssDiscounts.map(function (pss) {
        return pss.priceId;
      });

      if (!discountPrices || !discountPrices.length) {
        return [];
      }

      var _iterator = _createForOfIteratorHelper(discountPrices),
          _step;

      try {
        var _loop = function _loop() {
          var priceId = _step.value;

          if (pricesIds.findIndex(function (item) {
            return item === Number(priceId);
          }) > -1) {
            return "continue";
          }

          pricesIds.push(Number(priceId));
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    var searchTickets = computed(function () {
      var start = (currentPage.value - 1) * pageSize.value;
      var end = start + pageSize.value;
      return pricesList.value.slice(start, end).filter(function (price) {
        return price.categoryName.toLowerCase().includes(ticketsQuery.value.toLowerCase()) || price.priceName.toLowerCase().includes(ticketsQuery.value.toLowerCase()) || price.priceType.toLowerCase().includes(ticketsQuery.value.toLowerCase()) || String(price.priceValue).toLowerCase().includes(ticketsQuery.value.toLowerCase());
      });
    });
    var currency = computed(function () {
      var _BookingModule$select5;

      return (_BookingModule$select5 = BookingModule.selectedBooking) === null || _BookingModule$select5 === void 0 ? void 0 : _BookingModule$select5.currency;
    });

    function selectDiscountTickets(priceId) {
      selectedPrices.value.push(priceId);
    }

    function deSelectDiscountTickets(priceId) {
      var index = selectedPrices.value.findIndex(function (cat) {
        return cat === priceId;
      });

      if (index > -1) {
        selectedPrices.value.splice(index, 1);
      }
    }

    function confirmSelection() {
      // going to make discount appliable on some tickets
      BookingModule.updateDiscountCoverage({
        BookingUUID: BookingModule.selectedBookingUUID,
        isOnAllOrder: false
      });
      BookingModule.updateDiscountPrices({
        BookingUUID: BookingModule.selectedBookingUUID,
        pricesIds: selectedPrices.value
      });
      ModalModule.setStatus(ModalStatus.Hidden);
    }

    function cancelSelection() {
      // Clear the selected tickets and close it
      selectedPrices.value = [];
      ModalModule.setStatus(ModalStatus.Hidden);
    }

    function isPriceSelected(priceId) {
      return selectedPrices.value.some(function (prId) {
        return prId === priceId;
      });
    }

    return {
      dialogVisible: dialogVisible,
      pricesList: pricesList,
      iconStyle: iconStyle,
      iconContent: iconContent,
      iconAlt: iconAlt,
      currency: currency,
      isPriceSelected: isPriceSelected,
      selectDiscountTickets: selectDiscountTickets,
      deSelectDiscountTickets: deSelectDiscountTickets,
      confirmSelection: confirmSelection,
      cancelSelection: cancelSelection,
      totalPssListLength: totalPssListLength,
      ticketsQuery: ticketsQuery,
      searchTickets: searchTickets,
      pageSize: pageSize,
      currentPage: currentPage,
      changeCurrentPage: changeCurrentPage
    };
  }
});